/**
 * @flow
 */
import {EgretLoadable} from "../../../egret";
import {ROUTE} from '../../settings';

const reportsRoutes = [
  {path: ROUTE.REPORT_SUMMARY, component: EgretLoadable({loader: () => import("./ReportSummary")})},
  {path: ROUTE.REPORT_DAILY, component: EgretLoadable({loader: () => import("./ReportDaily")})},
  {path: ROUTE.REPORT_MONTHLY, component: EgretLoadable({loader: () => import("./ReportMonthly")})},
];

export default reportsRoutes;
